import { Link } from 'react-router-dom'

import { styled, Typography } from '@mui/material'

export const StyledHeader = styled('div')`
  display: flex;
  width: 100%;
  height: ${({ theme }) => theme.typography.pxToRem(62)};
  align-items: center;
  background-color: ${props => props.theme.palette.background.paper};
  box-shadow: ${props => props.theme.shadows[2]};
  border-bottom: 1px solid ${props => props.theme.palette.divider};
`

export const StyledContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0;
`

export const StyledLeftDrawer = styled('section')`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 100%;
  color: ${props => props.theme.palette.text.primary};
  background-color: ${props => props.theme.palette.background.paper};
  flex-direction: column;
  gap: ${props => props.theme.typography.pxToRem(8)};
  padding-top: ${props => props.theme.typography.pxToRem(16)};
  border-right: 1px solid ${props => props.theme.palette.divider};
`

export const StyledTitle = styled(Typography)`
  padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(12)};
`

export const StyledCategoryTitle = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(13)};
  color: ${props => props.theme.palette.text.secondary};
  padding-left: ${props => props.theme.typography.pxToRem(12)};
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`

export const StyledSecondaryNavItem = styled(Link, {
  shouldForwardProp: (prop) => prop !== '$active',
}) <{ $active?: boolean }>`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  letter-spacing: 0.03em;
  display: flex;
  align-items: center;
  height: ${(props) => props.theme.typography.pxToRem(36)};
  min-height: ${(props) => props.theme.typography.pxToRem(36)};
  text-decoration: none;
  color: ${(props) => props.theme.palette.custom.link.color};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  padding: 0 ${(props) => props.theme.typography.pxToRem(12)};
  overflow: hidden;
  gap: ${(props) => props.theme.typography.pxToRem(8)};
  white-space: nowrap;
  transition: background-color 150ms ease-in-out, color 150ms ease-in-out;

  ${(props) => props.theme.breakpoints.up('sm')} {
    &:hover {
      background-color: ${(props) => props.theme.palette.action.hover};
    }
  }

  ${(props) => props.$active && `
    background-color:  ${props.theme.palette.action.hover};
    color: ${props.theme.palette.text.primary};
    font-weight: 700;
  `}
`
